import {dateUtils} from "../../utils/dateUtils"
import flowapis from "../../api/yj"
import * as echarts from 'echarts' 
import { max } from "lodash";

export default {
    name: "LoanData",
    data() {
        var date=new Date()
        let year = date.getFullYear()
        let month = date.getMonth()+1
        month = month<10?'0'+month:month
        let day = date.getDate()
        day = day<10?'0'+day: day
        let thisDate = year+"-"+month+'-'+day
        let month2 = date.getMonth()+1;
        let year2=year;
        if (month2 < 6) {
         month2 += 7;
         year2--;
        }else  month2 = 1;
        month2 = month2<10?'0'+month2:month2
        return {
            scrollHeight: 400,
            time: year +"-"+month,
            timeY: year+'',
            chooseType: 'month',
            weekStatistic: {},
            monthStatistic: {},
            yearStatistic: {},
            allStatistic: {},
            zaibaoStatistic: {},
            chartStatistic:{},
            customChartStatistic: {},
            projectNameArr: [],
            chooseProjectNames: [],
            dateRange2: [year+'-01-01', thisDate],
            dateRange1: [year2+"-"+month2, year+"-"+month],
            dateRange: ["", ""],
            flag:0,
            zsflag:"1",
            datalist1:[],
            datalist2:[],
                xmlist:[],
                arealist:[],
                yhlist:[],
                dblist:[],
                query:{
                    personflag:"",
                    yh:"",
                    db:"",
                }
        };
    },
    created() {
        let that = this;
        that.$nextTick(() => {
            that.getData()
            that.getChartData1()
            that.getChartData2()
        });
    },
    beforeMounted() {
    },
    mounted() {
        let that = this;
        that.calcTableHeight();
        // 注：window.onresize只能在项目内触发1次
        window.onresize = function windowResize() {
            that.calcTableHeight();
        }
    },
    methods: {
        getData() {
            let that = this
            flowapis.getPCSumData({}).then(res => {
                that.weekStatistic = res.weekStatistic
                that.monthStatistic = res.monthStatistic
                that.yearStatistic = res.yearStatistic
                that.allStatistic = res.allStatistic
                that.dblist=res.userlist1;
                that.yhlist=res.userlist2;

            })
        },
       getDataFour(){
            var that=this;
            var params=that.query;
            if(that.dateRange!=null&&that.dateRange[0]!=""){
                params.startTime= that.dateRange[0]+' 00:00:00';
                params.endTime=that.dateRange[1]+' 23:59:59';
            }else{
                params.startTime= ""
                params.endTime= ""
            }
            flowapis.getDataFourByCondition(params).then(res=>{
                 that.weekStatistic = res.weekStatistic
                that.monthStatistic = res.monthStatistic
                that.yearStatistic = res.yearStatistic
                that.allStatistic = res.allStatistic
            })
        },
        getChartData1() {
            let that = this
            let params = {
                startTime: that.dateRange1[0],
                endTime: that.dateRange1[1],
            }
            flowapis.getDataChart1(params).then(res=>{
                that.datalist1 =res;
                that.updateChart1()
            })
        },
        getChartData2() {
            let that = this
            let params = {
                startTime: that.dateRange2[0]+' 00:00:00',
                endTime: that.dateRange2[1]+' 23:59:59',
                flag:that.zsflag
            }
            flowapis.getDataChart2(params).then(res=>{
                if(that.zsflag==1&&res.length>12)res=res.slice(0,12)
                that.datalist2 =res
                that.updateChart2()
            })
          },
        updateChart2(){
            let dataArr = this.datalist2
            let chart = {}
            chart = this.$root.echarts.init(
                document.getElementById("echarts2")
            );
            let projectArr = []
            let totalArr = []
            let priceArr = []
            var flag=this.zsflag;
            var personlist=["个人","企业"]
            var maxNum=5;
            for(let i=0;i<dataArr.length;i++){
                if(flag==3)projectArr.push(personlist[dataArr[i].PersonFlag-1])
                else projectArr.push(dataArr[i].UserName)
                totalArr.push(dataArr[i].num)
                priceArr.push(dataArr[i].sum)
                if(dataArr[i].num>maxNum){
                    maxNum=dataArr[i].num;
                }
            }
            if(maxNum>20) maxNum=maxNum+9-(maxNum+9)%10;
            else maxNum=maxNum+4-(maxNum+4)%5;
            if(dataArr.length==0){
                 projectArr = ["无数据"]
                 totalArr = [0]
                 priceArr = [0]
            }
            // var colors = ['#d3dee5', '#ADC367'];

            let option = {
                // color: colors,
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross'
                    }
                },
                legend: {
                    data: ['金额','数量']
                },
                xAxis: [
                    {
                        type: 'category',
                        axisTick: {
                            alignWithLabel: true
                        },
                        data: projectArr,
                        axisLabel: {
                            interval: 0,
                            // 文字换行
                            formatter: function (value) {
                              let res = ""; // 拼接加\n返回的类目项
                              let maxLength = 9; // 每项显示文字个数  数字设置几，就一行显示几个文字
                              if(projectArr.length<4)maxLength=20; 
                              else if(projectArr.length>10)maxLength=4; 
                              else if(projectArr.length>6)maxLength=6; 
                              let valLength = value.length; // X轴上的文字个数
                              let rowN = Math.ceil(valLength / maxLength); // 需要换行的行数
                              // 换行的行数大于1,
                              if (rowN > 1) {
                                for (let i = 0; i < rowN; i++) {
                                  let temp = ""; //每次截取的字符串
                                  let start = i * maxLength; //开始截取的位置
                                  let end = start + maxLength; //结束截取的位置
                                  temp = value.substring(start, end) + "\n";
                                  res += temp; //拼接字符串
                                }
                                return res;
                              } else {
                                return value;
                              }
                            },
                          },
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        name: '数量',
                        min: 0,
                        max:maxNum,
                        position: 'right',
                        axisLine: {
                            lineStyle: {
                                // color: colors[1]
                            }
                        },
                        axisLabel: {
                            formatter: '{value} 笔'
                        }
                    },
                    
                    {
                        type: 'value',
                        name: '金额',
                        min: 0,
                        position: 'left',
                        axisLine: {
                            lineStyle: {
                                // color: colors[0]
                            }
                        },
                        axisLabel: {
                            formatter: '{value} 万元'
                        }
                    }
                ],
                series: [
                    {
                        name: '金额',
                        type: 'bar',
                        barWidth: '12px',
                        itemStyle: {
                            normal: {
                                color: new this.$root.echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: '#fccb05'
                                }, {
                                    offset: 1,
                                    color: '#f5804d'
                                }]),
                                barBorderRadius: 11,
                            }

                        },
                        yAxisIndex: 1,
                        data: priceArr
                    },
                    {
                        name: '数量',
                        type: 'bar',
                        data: totalArr,
                        barWidth: '12px',
                        itemStyle: {
                                normal: {
                                    color: new this.$root.echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                        offset: 0,
                                        color: '#8bd46e'
                                    }, {
                                        offset: 1,
                                        color: '#09bcb7'
                                    }]),
                                barBorderRadius: 12,
                            },
                        },
                    },
                ]
            };

            chart.setOption(option)
        },
        updateChart1(){
            let dataArr = this.datalist1
            let chart = {}
            chart = this.$root.echarts.init(
                document.getElementById("echarts1")
            );
            let projectArr = []
            let totalArr = []
            let priceArr = []
            var maxNum=5;
            for(let i=0;i<dataArr.length;i++){
                projectArr.push(dataArr[i].month)
                totalArr.push(dataArr[i].num)
                priceArr.push(dataArr[i].sum)
                if(dataArr[i].num>maxNum){
                    maxNum=dataArr[i].num;
                }
            }
            if(maxNum>20) maxNum=maxNum+9-(maxNum+9)%10;
            else maxNum=maxNum+4-(maxNum+4)%5;
            // var colors = ['#d3dee5', '#ADC367'];

            let option = {
                // color: colors,
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross'
                    }
                },
                legend: {
                    data: ['金额','数量']
                },
                xAxis: [
                    {
                        type: 'category',
                        axisTick: {
                            alignWithLabel: true
                        },
                        data: projectArr,
                        axisLabel: {
                            interval: 0,
                            // 文字换行
                            formatter: function (value) {
                              let res = ""; // 拼接加\n返回的类目项
                              let maxLength = 9; // 每项显示文字个数  数字设置几，就一行显示几个文字
                              if(projectArr.length<4)maxLength=20; 
                              else if(projectArr.length>10)maxLength=4; 
                              else if(projectArr.length>6)maxLength=6; 
                              let valLength = value.length; // X轴上的文字个数
                              let rowN = Math.ceil(valLength / maxLength); // 需要换行的行数
                              // 换行的行数大于1,
                              if (rowN > 1) {
                                for (let i = 0; i < rowN; i++) {
                                  let temp = ""; //每次截取的字符串
                                  let start = i * maxLength; //开始截取的位置
                                  let end = start + maxLength; //结束截取的位置
                                  temp = value.substring(start, end) + "\n";
                                  res += temp; //拼接字符串
                                }
                                return res;
                              } else {
                                return value;
                              }
                            },
                          },
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        name: '数量',
                        min: 0,
                        max:maxNum,
                        position: 'right',
                        axisLine: {
                            lineStyle: {
                                // color: colors[1]
                            }
                        },
                        axisLabel: {
                            formatter: '{value} 笔'
                        }
                    },
                    
                    {
                        type: 'value',
                        name: '金额',
                        min: 0,
                        position: 'left',
                        axisLine: {
                            lineStyle: {
                                // color: colors[0]
                            }
                        },
                        axisLabel: {
                            formatter: '{value} 万元'
                        }
                    }
                ],
                series: [
                    {
                        name: '金额',
                        type: 'line',
                        itemStyle: {
                            normal: {
                                color: new this.$root.echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: '#fccb05'
                                }, {
                                    offset: 1,
                                    color: '#f5804d'
                                }]),
                                barBorderRadius: 11,
                            }

                        },
                        yAxisIndex: 1,
                        data: priceArr
                    },
                    {
                        name: '数量',
                        type: 'line',
                        data: totalArr,
                        barWidth: '12px',
                        itemStyle: {
                                normal: {
                                    color: new this.$root.echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                        offset: 0,
                                        color: '#8bd46e'
                                    }, {
                                        offset: 1,
                                        color: '#09bcb7'
                                    }]),
                                barBorderRadius: 12,
                            },
                        },
                    },
                ]
            };

            chart.setOption(option)
        },
        calcTableHeight() {
            this.$nextTick(() => {
                var height1 = $(".content-box .content").height();
                var height2 = $(".content-box .content .seach-container").height();
                var height = height1 - height2 - 112 - 40;
                this.scrollHeight = height;
            });
        },
    },
};
